import { BoostCoverTable } from '@packages/types';

import { Text } from '@elements/text';
import { sluggify, testProps } from '@utils';

interface Props {
  item: BoostCoverTable;
}

export const TableItem = ({ item }: Props) => {
  return (
    <div className="pb-s16">
      <Text
        variant="body-16/sb"
        className="pb-s16"
        {...testProps(sluggify(item.columnNames.title))}>
        {item.columnNames.title}
      </Text>
      <table className="w-full">
        <tbody>
          {item.items.map((rowItem, index) => {
            return (
              <tr className="border-y-2 border-gray-200" key={index}>
                <td className="py-4 px-0">
                  <Text variant="body-16/r" {...testProps(sluggify(rowItem.title))}>
                    {rowItem.title}
                  </Text>
                  {rowItem.child && (
                    <ul>
                      <li className="list-disc mx-8 ">
                        <Text variant="body-16/r" {...testProps(sluggify(rowItem.child.title))}>
                          {rowItem.child.title}
                        </Text>
                      </li>
                    </ul>
                  )}
                </td>
                <td className="py-4 text-right">
                  <Text
                    variant="body-16/sb"
                    {...testProps(`${sluggify(rowItem.title)}-description`)}>
                    {rowItem.value}
                  </Text>
                  {rowItem.child && (
                    <Text variant="body-16/r" {...testProps(sluggify(rowItem.child.value))}>
                      {rowItem.child.value}
                    </Text>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
